var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { attrs: { name: "query-sort-block" } },
        [
          _c("swb-query-sort-area", {
            ref: "query_model_ctrl",
            attrs: {
              config: _vm.queryConfig,
              queryOnLoad: _vm.queryOnLoad,
              mountedHandler: _vm.onQueryConfigReady,
              queryHandler: _vm.queryHandler
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.dataList, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              width: "40",
              selectable: _vm.canSelectRow,
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "name",
              label: "字段编码",
              width: "200"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "title",
              label: "中文标题",
              width: "200"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "left", prop: "type", label: "类型", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.typeMap[rows.row.type]))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "left", prop: "desc", label: "说明" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", width: "100", label: "必填项" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c("el-checkbox", {
                      attrs: { disabled: !_vm.canSelectRow(rows.row) },
                      model: {
                        value: rows.row.required,
                        callback: function($$v) {
                          _vm.$set(rows.row, "required", $$v)
                        },
                        expression: "rows.row.required"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eb6aa8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb6aa8c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devcCust/DevcCustFieldListSelect.vue
// module id = 2450
// module chunks = 0